import styled from "styled-components";

export const TextWarning = styled.p`
  text-align: center;
  width: 367px
`;